"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRegisterRequest = void 0;
var UserRegisterRequest = /** @class */ (function () {
    function UserRegisterRequest() {
    }
    return UserRegisterRequest;
}());
exports.UserRegisterRequest = UserRegisterRequest;
//# sourceMappingURL=userRegister.request.js.map